function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinanceGraphArrow001({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "finance_x5F_graph_x5F_arrow_x5F_001",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FD5C3F"
    },
    points: "32,32 0,32 0,0 2,0 2,30 32,30  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FD5C3F"
    },
    points: "8.414,25 1,25 1,23 7.586,23 15.586,15 22.586,15 29.293,8.293 30.707,9.707 23.414,17  16.414,17  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FD5C3F"
    },
    points: "32,13 30,13 30,9 26,9 26,7 32,7  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceGraphArrow001);
export default __webpack_public_path__ + "static/media/finance_graph_arrow_001.8d878e20873014e7ebc26019b4685c23.svg";
export { ForwardRef as ReactComponent };